import { render } from "./searchHumanityVideo.vue?vue&type=template&id=15a91502&scoped=true"
import script from "./searchHumanityVideo.vue?vue&type=script&lang=js"
export * from "./searchHumanityVideo.vue?vue&type=script&lang=js"

import "./searchHumanityVideo.vue?vue&type=style&index=0&id=15a91502&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a91502"]])

export default __exports__